import {
  ref,
  Ref,
  getCurrentInstance,
  onUnmounted,
  computed
} from '@vue/composition-api'
import { Route } from 'vue-router'

export function useUnsavedWarning({
  message = 'Do you really want to leave? you have unsaved changes!',
  shouldWarn = () => true
}: {
  message?: string
  shouldWarn?: (route: Route) => boolean
} = {}): {
  markAsDirty: () => void
  resetDirty: () => void
  isDirty: Ref<boolean>
} {
  const dirty = ref(false)
  const notDirty = computed(() => !dirty.value)
  const markAsDirty = (): void => {
    dirty.value = true
  }
  const resetDirty = (): void => {
    dirty.value = false
  }

  const vm = getCurrentInstance()
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const removeRouteGuard = vm!.$router.beforeEach((to, _from, next) => {
    if (notDirty.value) {
      next()
      return
    }

    if (!shouldWarn(to)) {
      next()
      return
    }

    const answer = window.confirm(message)
    if (answer) {
      next()
    } else {
      next(false)
    }
  })

  // eslint-disable-next-line
  const promptOnUnload = (e: any): string | undefined => {
    if (notDirty.value) {
      return
    }
    ;(e || window.event).returnValue = message //Gecko + IE
    return message //Gecko + Webkit, Safari, Chrome etc.
  }
  window.addEventListener('beforeunload', promptOnUnload)

  onUnmounted(() => {
    removeRouteGuard()
    window.removeEventListener('beforeunload', promptOnUnload)
  })

  return {
    isDirty: computed(() => dirty.value),
    markAsDirty,
    resetDirty
  }
}
